export default __webpack_public_path__ + "static/media/turn-ideas-into-reality-1440w.4c87e77a.png";